/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Vue } from 'vue-property-decorator';
import ErrorResponseMixin from '@mixin/errorResponse';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({

    data() {
        return {
        };
    },

    mixins: [
        ErrorResponseMixin,
    ],

    created() {
        if (this.onNext) {
            this.next.onNext = this.onNext;
        }
    },
})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class StateMixin extends Vue {}